import { Location } from '@angular/common';
import { Component, inject, LOCALE_ID, OnDestroy } from '@angular/core';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { BreakpointObserverService } from '@visiativ/digital-components-kit';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'app-legal-documents',
	styleUrls: ['./legal-documents.component.scss'],
	templateUrl: './legal-documents.component.html',
	standalone: true,
	imports: [MatTabGroup, MatTab],
})
export class LegalDocumentsComponent implements OnDestroy {
	private readonly location = inject(Location);
	private readonly router = inject(Router);
	private readonly sanitizer = inject(DomSanitizer);
	public readonly breakpointObserverService = inject(BreakpointObserverService);
	private readonly localeId = inject(LOCALE_ID);
	private readonly locale: string = this.localeId;
	public actualTab = '';
	public confidentialPolicyUrl: SafeResourceUrl;
	public matomoIframeUrl: SafeResourceUrl;
	public cguUrl = '';
	public indexTab = 0;
	private readonly unsubscribeSubject = new Subject<void>();
	public tabsLink = [
		{
			name: 'cgu',
			tab: $localize`:@@hub.global.legal-cgu-label:CGU`,
			label: $localize`:@@hub.legal-documents.cgu-title-label:Conditions générales d'utilisation`,
		},
		{
			name: 'legal_notice',
			tab: $localize`:@@hub.global.legal-notice-label:Mentions légales`,
			label: $localize`:@@hub.global.legal-notice-label:Mentions légales`,
		},
		{
			name: 'privacy_policy',
			tab: $localize`:@@hub.global.legal-privacy-policy-label:Politique de confidentialité`,
			label: $localize`:@@hub.global.legal-privacy-policy-label:Politique de confidentialité`,
		},
	];

	constructor() {
		this.router.events.pipe(takeUntil(this.unsubscribeSubject)).subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.actualTab = event.url.split('/legal_documents/')[1];

				Object.entries(this.tabsLink).forEach(([key, value]) => {
					if (this.actualTab === value['name']) {
						this.indexTab = Number.parseInt(key);
					}
				});
				this.location.replaceState('/legal_documents');
			}
		});
		this.matomoIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
			`https://visiativ.matomo.cloud/index.php?module=CoreAdminHome&action=optOut&language=${this.locale}`,
		);
		this.confidentialPolicyUrl = this.sanitizer.bypassSecurityTrustUrl(
			$localize`:@@hub.legal-documents.privacy-policy-url:https://www.visiativ.com/wp-content/uploads/2023/05/politique-donnees-personnelles-groupevisiativ-240523.pdf`,
		);
		this.cguUrl = $localize`:@@hub.legal-documents.cgu-url:https://www.visiativ.com/wp-content/uploads/2023/11/fr-visiativ-cgu-20231011.pdf`;
	}

	ngOnDestroy(): void {
		this.unsubscribeSubject.next();
		this.unsubscribeSubject.complete();
	}
}
